import { qspost } from '@/config/axios';

// 获取列表数据
export const getList = data => qspost("request?", data, "ysTradLog");